import React from 'react';
import { IAuditoriaDuplicidadePagamentosResultado } from '../interfaces/IAuditoriaDuplicidadePagamentos';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaDuplicidadePagamentosResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Detecção, Classificação e Encaminhamento de Erros de Perda Financeira — pagamentos em
// duplicidade (mesma nota fiscal + mesmo valor, sem estorno no mês) em contas de Custo/Despesa
// (grupo 3). Fundamentação: CPC 26 / IFRS / Lei nº 6.404/1976, Art. 177.
const AuditoriaResumoDuplicidadePagamentos: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.duplicidades?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Perda Financeira (Duplicidade de Pagamentos)</h3>
      <p className='text-muted'>
        Pagamentos com a mesma nota fiscal e o mesmo valor, em contas de Custo/Despesa, sem estorno no mês,
        configuram perda financeira por falha de controle interno (CPC 26 / IFRS). Clique para ver a análise
        detalhada e os lançamentos que comprovam a duplicidade.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Perda Financeira</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_DUPLICIDADE_PAGAMENTOS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Erros de Perda Financeira (Duplicidade de Pagamentos)</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} grupo{totalOcorrencias === 1 ? '' : 's'} de duplicidade identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} lançamento{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Quadro de Resumo de Perda Financeira</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoDuplicidadePagamentos;
